interface inconType {
  size?: number;
  color?: string;
}

export const ArrowDown = ({ size = 15, color = "black" }: inconType) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.68038 0.688112C1.61359 0.628022 1.53502 0.581046 1.44916 0.549865C1.3633 0.518683 1.27183 0.503908 1.17998 0.506381C1.08812 0.508855 0.997672 0.52853 0.913801 0.564283C0.82993 0.600036 0.754277 0.651165 0.691162 0.714754C0.628046 0.778342 0.578704 0.853143 0.545952 0.934886C0.513201 1.01663 0.497681 1.10371 0.50028 1.19117C0.502878 1.27862 0.523544 1.36473 0.561097 1.44458C0.59865 1.52443 0.652355 1.59645 0.719145 1.65654L7.01545 7.31794C7.14534 7.43486 7.31731 7.5 7.49607 7.5C7.67482 7.5 7.84679 7.43486 7.97669 7.31794L14.2737 1.65654C14.3419 1.59685 14.3971 1.52484 14.4358 1.4447C14.4746 1.36455 14.4963 1.27788 14.4996 1.18969C14.5028 1.10151 14.4877 1.01359 14.455 0.931028C14.4223 0.848467 14.3727 0.772915 14.3091 0.708761C14.2454 0.644606 14.169 0.593129 14.0843 0.557318C13.9996 0.521507 13.9083 0.502077 13.8156 0.500156C13.723 0.498235 13.6308 0.513861 13.5446 0.546127C13.4583 0.578393 13.3797 0.626655 13.3132 0.688111L7.49607 5.91791L1.68038 0.688112Z"
        fill={color}
      />
    </svg>
  );
};
